import React, {} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button} from "@mui/material";
import ShuffleIcon from "@mui/icons-material/Shuffle";

import {FEATURE_PICKER_TYPE} from "../../../../../constants";
import {setFeaturePicker} from "../../../../../../../actions/sqftMenuFunctions";
import sqftShape from "../../../../canvas/core/shapes/sqftShape";
import ConfirmButtons from "../ConfirmButtons";
import {changeShapeLayout} from "../../../../../helpers/cabinetsHelper";
import {setResourceControllerCounter} from "../../../../../../../actions/sqftResourceFunctions";

const CustomSizeSwapButton = (props) => {
  const {featurePicker, setFeaturePicker, selectedFeatureInPicker, setResourceControllerCounter,
    resourceControllerCounter} = props;
  const {shape} = props;

  const swapCabinetClick = () => {
    setFeaturePicker(
      {
        isOpen: true,
        modelId: "",
        featureId: shape.featureId,
        sharedFeatureName: shape.getFeature().dbFeature.sharedFeatureName,
        partIds: [shape.partId],
        shapeId: shape.id,
        type: FEATURE_PICKER_TYPE.shape
      }
    )
  }

  const confirmCallback = () => {
    shape.setFeatureId(selectedFeatureInPicker);
    const feature = shape.getFeature();
    changeShapeLayout(feature, shape);

    setResourceControllerCounter(resourceControllerCounter + 1);
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  };

  return (
    featurePicker.isOpen
    && featurePicker.type === FEATURE_PICKER_TYPE.shape
      ? <ConfirmButtons confirmCallback={confirmCallback}/>
      : <Button
        className={"sr__button "}
        variant="outlined"
        color="primary"
        startIcon={<ShuffleIcon style={{ transform: 'rotate(180deg)' }}/>}
        onClick={swapCabinetClick}
      >
        <FormattedMessage id={"Swap Cabinet"}/>
      </Button>
  );
};

CustomSizeSwapButton.prototype = {
  shape: PropTypes.instanceOf(sqftShape)
}

const mapStateToProps = (store) => {
  const {featurePicker, selectedFeatureInPicker} = store.sqftMenuState;
  const {resourceControllerCounter} = store.sqftResourceState;

  return {
    featurePicker: featurePicker,
    selectedFeatureInPicker: selectedFeatureInPicker,
    resourceControllerCounter: resourceControllerCounter,
  }
};

const mapDispatchToProps = {
  setFeaturePicker,
  setResourceControllerCounter,
};


export default connect(mapStateToProps, mapDispatchToProps)(CustomSizeSwapButton);
